import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';

import { CountryPickerModule } from '../../country-picker/country-picker.module';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { AddressDetailsFormService } from '@go-modules/services/address-details-form/address-details-form.service';

@Component({
	selector: 'address-details-form',
	templateUrl: './address-details-form.component.html',
	styleUrls: ['./address-details-form.component.scss'],
	standalone: true,
	imports: [
		ReactiveFormsModule,
		TranslateModule,
		CountryPickerModule,
		GoMaterialModule
	]
})
export class AddressDetailsFormComponent {

	public constructor (public addressForm: AddressDetailsFormService) {}
}
